import React from 'react';
import classNames from "classnames";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import mapStyle from "assets/jss/prehnit/components/mapStyle.jsx";

import { withNamespaces } from "react-i18next";

import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Icon from "@material-ui/core/Icon";

// core components
// import GridContainer from "components/Grid/GridContainer.jsx";
// import GridItem from "components/Grid/GridItem.jsx";

class SideContent extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      selectedTabIndex: 0
    }

    this.handleChange = this.handleChange.bind(this);
    this.handleClose = this.handleClose.bind(this);

  }

  handleChange(event, newValue) {
    this.setState({
      selectedTabIndex: newValue
    })
  }

  handleClose() {
    this.handleChange(null, 0);
    if (this.props.onClose) {
      this.props.onClose();
    }
  }

  render() {
    const { classes } = this.props;

    const children = React.Children.toArray(this.props.children).filter(o => o); //clear null elements

    let propClass = '';

    if (this.props.right) {
      propClass = classes.sideContentRight;
    } else if (this.props.left) {
      propClass = classes.sideContentLeft;
    }

    if (children.length > 0) {
      return (
        <div className={classNames(classes.menu, classes.sideContent, propClass)}>
          <Tabs value={this.state.selectedTabIndex} onChange={this.handleChange} indicatorColor="secondary" variant="fullWidth" scrollButtons="on">
            {React.Children.map(children, (child, i) => {
              if (child != null) {
                return (
                  <Tab key={i} className={classes.tabsLayerInfoLegend} icon={<Icon>{child.props.icon}</Icon>}/>
                );
              } else {
                return null;
              }
            })}
            <Tab key={999} className={classes.tabsLayerInfoLegend} icon={<Icon>clear</Icon>} onClick={this.handleClose}/>
          </Tabs>

          {React.Children.map(children, (child, i) => {
              if (child != null && this.state.selectedTabIndex === i) {
                return (
                  <div>{child}</div>
                );
              } else {
                return null;
              }
            })}

        </div>
        );
    } else {
      return null;
    }

  }
}

export default withNamespaces()(withStyles(mapStyle)(SideContent));
